export default function PHP_htmlspecialchars() {
  return (
    <div>
      <h1>PHP_htmlspecialchars</h1>
    </div>
  );
}
